/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import { useDeviceDetect } from 'hooks';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function CustomCheckboxesGroup({ options, label, error, children, helperText, column, value, onChange, name, onBlur, optionClasses }) {
  const classes = useStyles();
  const { isDesktop } = useDeviceDetect();
  return (
    <FormControl className={classes.formControl} component="fieldset" error={error} name={name} onBlur={onBlur}>
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <FormGroup className={classes.formGroup} aria-label="language" row={isDesktop && !column}>
        {options.map((option) => {
          const { value: optionValue, label: optionLabel, disabled } = option;
          return (
            optionValue && (
              <FormControlLabel
                className={cn(classes.option, optionClasses)}
                key={optionValue}
                label={
                  <Typography component="span" variant="body1" classes={{ root: value.includes(optionValue) ? classes.activeCheckboxLabel : classes.checkboxLabel }}>
                    {optionLabel}
                  </Typography>
                }
                control={
                  <Checkbox
                    data-testid="checkbox"
                    className={classes.checkbox}
                    value={value}
                    name={optionValue}
                    checked={value.includes(optionValue)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        const newValue = [...value];
                        newValue.push(optionValue);
                        onChange(newValue);
                      } else {
                        onChange(value.filter((item) => item !== optionValue));
                      }
                    }}
                    disabled={disabled || false}
                    color="primary"
                  />
                }
              />
            )
          );
        })}
        {children}
      </FormGroup>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}

CustomCheckboxesGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.element,
  onChange: PropTypes.func,
  column: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.any),
  optionClasses: PropTypes.string,
  ...FormGroup.propTypes,
};

CustomCheckboxesGroup.defaultProps = {
  children: null,
  column: false,
  value: [],
  label: null,
  options: [],
  onChange: () => {},
  optionClasses: '',
};

export default CustomCheckboxesGroup;
